<template>
	<div class="rank">
		<header class="d-flex j-sb a-center" style="height: 1.69rem;">
			<div class="search">
				<input type="text" v-model="search_input" placeholder="输入商品编号/商品名称">
				<div @click="searchKeyword" class="icon d-flex j-center a-center" style="cursor: pointer;">
					<i class="el-icon-search"></i>
				</div>
			</div>
			<ul class="period d-flex j-sb a-center">
				<li class="d-flex j-center a-center" @click="setIndex(index)" :class="curIndex==index?'active':''" v-for="(item,index) in period" :key="index">{{item}}</li>
			</ul>
			<div class="chooseDate d-flex j-center a-center" style="height: 100%; font-size: 1rem;position: relative;">
				<el-date-picker ref="input_period" prefix-icon="none" :clearable="false" v-model="input_period" style="padding-right: 0;padding-left: 0; width: 15rem; height: 100%; border: 2px solid #1E69FF; border-radius: 4px 0 0 4px;"
				 type="monthrange" value-format="yyyy-MM" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
				<img @click="$refs.input_period.focus()" src="@/assets/Home/xuanzeriqi@2x.png" style="cursor: pointer; width: 0.85rem;height: 0.85rem;position: absolute;right: 4.15rem;">
				<button @click="query" style="font-size: 1rem; background: #1E69FF;color: #FFFFFF;border: none;height: 100%;outline: none;padding: 0 0.85rem; border-radius: 0 4px 4px 0;cursor: pointer;">查询</button>
			</div>
		</header>
		<div class="content d-flex j-start flex-column a-center">
			<div class="title" style="align-self: flex-start;font-size: 1rem;font-weight: 700;">
				门店数据排行
			</div>
			<div class="wrap flex-1 w-100">
				<div class="table h-100 w-100 d-flex flex-column j-start a-sb">
					<div class="d-flex j-sb a-center" style="height: 10%;font-weight: 700;font-size: 0.75rem;">
						<span style="flex: .3;">排名</span>
						<span class="flex-1">门店编号</span>
						<span style="flex: 1.5;">分公司名称</span>
						<div class="flex-1 d-flex j-center a-center" style="flex:1;">
							<span style="line-height: 1rem;">客流量<span style="font-size: 0.75rem;color: #666666;">(人次)</span></span>
							<div class="sort d-flex flex-column j-sb a-center" @click="changeSort('money')" style="cursor: pointer;">
								<div :style="orderByMoney && !money_isDesc?'border-bottom-color: #FF3131;':'border-bottom-color: #BBBBBB;'" style="border: 0.43rem solid transparent;margin-bottom: .05rem; transform: scaleX(.5);"></div>
								<div :style="orderByMoney && money_isDesc?'border-top-color: #FF3131;':'border-top-color: #BBBBBB;'" style="border: 0.43rem solid transparent;margin-top: .05rem; transform: scaleX(.5);"></div>
							</div>
						</div>
						<div class="d-flex j-center a-center" style="flex:1;">
							<span style="line-height: 1rem">订单量<span style="font-size: 0.75rem;color: #666666;">(笔)</span></span>
							<div class="sort d-flex flex-column j-sb a-center" @click="changeSort('num')" style="cursor: pointer;">
								<div :style="orderByNum && !num_isDesc?'border-bottom-color: #FF3131;':'border-bottom-color: #BBBBBB;'"
								 style="border: 0.43rem solid transparent;margin-bottom: .05rem; transform: scaleX(.5);"></div>
								<div :style="orderByNum && num_isDesc?'border-top-color: #FF3131;':'border-top-color: #BBBBBB;'" style="border: 0.43rem solid transparent;margin-top: .05rem; transform: scaleX(.5);"></div>
							</div>
						</div>
						<div class="flex-1 d-flex j-center a-center" style="flex:1;">
							<span style="line-height: 1rem;">成交金额<span style="font-size: 0.75rem;color: #666666;">(元)</span></span>
							<div class="sort d-flex flex-column j-sb a-center" @click="changeSort('quantitynum')" style="cursor: pointer;">
								<div :style="quantityNum && !quantitynum_isDesc?'border-bottom-color: #FF3131;':'border-bottom-color: #BBBBBB;'" style="border: 0.43rem solid transparent;margin-bottom: .05rem; transform: scaleX(.5);"></div>
								<div :style="quantityNum && quantitynum_isDesc?'border-top-color: #FF3131;':'border-top-color: #BBBBBB;'" style="border: 0.43rem solid transparent;margin-top: .05rem; transform: scaleX(.5);"></div>
							</div>
						</div>
						<div class="d-flex j-center a-center" style="flex:1;">
							<span style="line-height: 1rem">总采购数量<span style="font-size: 0.75rem;color: #666666;">(件)</span></span>
							<div class="sort d-flex flex-column j-sb a-center" @click="changeSort('quantitymoney')" style="cursor: pointer;">
								<div :style="quantityMoney && !quantitymoney_isDesc?'border-bottom-color: #FF3131;':'border-bottom-color: #BBBBBB;'"
								 style="border: 0.43rem solid transparent;margin-bottom: .05rem; transform: scaleX(.5);"></div>
								<div :style="quantityMoney && quantitymoney_isDesc?'border-top-color: #FF3131;':'border-top-color: #BBBBBB;'" style="border: 0.43rem solid transparent;margin-top: .05rem; transform: scaleX(.5);"></div>
							</div>
						</div>
						<div class="d-flex j-center a-center" style="flex:1;">
							<span style="line-height: 1rem">总采购金额<span style="font-size: 0.75rem;color: #666666;">(元)</span></span>
							<div class="sort d-flex flex-column j-sb a-center" @click="changeSort('tMoney')" style="cursor: pointer;">
								<div :style="tMoney && !tMoney_isDesc?'border-bottom-color: #FF3131;':'border-bottom-color: #BBBBBB;'"
								 style="border: 0.43rem solid transparent;margin-bottom: .05rem; transform: scaleX(.5);"></div>
								<div :style="tMoney && tMoney_isDesc?'border-top-color: #FF3131;':'border-top-color: #BBBBBB;'" style="border: 0.43rem solid transparent;margin-top: .05rem; transform: scaleX(.5);"></div>
							</div>
						</div>
					</div>
					<div class="row d-flex j-sa a-center" style="font-size: 0.66rem;height: 9%;color: #666666;" v-for="(item,index) in rank"
					 :key="index">
						<div style="flex: .3;">
							<img v-if="index < 3" :src="index==0?require('@/assets/Home/diyi@2x.png'):index==1?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
							 style="width: 1.56rem;height: 1.56rem;">
							<span v-else>{{index+1}}</span>
						</div>
						<div>{{item.id}}</div>
						<div style="flex: 1.5;">
							<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
								<img :src="item.stores_logo" style="width: 1.88rem;height: 1.88rem;margin-right: 0.58rem;" v-if="item.stores_logo">
								<span style="text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.agent_name}}</span>
							</div>
						</div>
						<span style="flex: 1;">{{item.visit_num}}</span>
						<span style="flex: 1;">{{item.order_num}}</span>
						<span style="flex: 1;">{{item.sales_volume}}</span>
						<span style="flex: 1;">{{item.purchase_volume}}</span>
						<span style="flex: 1;">{{item.purchase_amount}}</span>
					</div>
				</div>
			</div>
		</div>
		<footer class="d-flex j-end a-center">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
			 :page-size="10" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				search_input: '',
				orderByNum: true,
				orderByMoney: false,
				quantityNum : false,
				quantityMoney : false,
				tMoney : false,
				num_isDesc: true,
				money_isDesc: true,
				quantitymoney_isDesc : false,
				quantitynum_isDesc : false,
				tMoney_isDesc : false,
				currentPage: 1, //初始页
				pageSize: 10, //    每页的数据
				rank: [],
				input_period: [],
				curIndex: -1,
				period: ['今天', '昨天', '近30天', '近3个月', '近6个月'],
				start_month:'',
				end_month:'',
				total_records:0,
				agent_id : '',
				sort_field : 'order_num'
			}
		},
		watch: {
			orderByNum(newValue, oldValue) {
				if (newValue == false) {
					this.num_isDesc = false
				}
			},
			orderByMoney(newValue, oldValue) {
				if (newValue == false) {
					this.money_isDesc = false
				}
			},
			quantityNum(newValue, oldValue) {
				if (newValue == false) {
					this.quantitynum_isDesc = false
				}
			},
			quantityMoney(newValue, oldValue) {
				if (newValue == false) {
					this.quantitymoney_isDesc = false
				}
			},
			tMoney(newValue, oldValue) {
				if (newValue == false) {
					this.tMoney_isDesc = false
				}
			}
		},
		methods: {
			searchKeyword(){
				this.getData()
			},
			query() {
				this.start_month = this.input_period[0],
				this.end_month = this.input_period[1]
				this.curIndex = -1
				this.getData()
			},
			setIndex(index){
				this.curIndex = index
				this.start_month = '',
				this.end_month = '',
				this.getData()
			},
			changeSort(type) {
				if (type == 'num') {
					this.sort_field = 'order_num'
					this.orderByNum = true
					this.orderByMoney = false
					this.quantityNum = false
					this.quantityMoney = false
					this.tMoney = false
					this.num_isDesc = !this.num_isDesc
				} else if(type == 'money') {
					this.sort_field = 'visit_num'
					this.orderByNum = false
					this.orderByMoney = true
					this.quantityNum = false
					this.quantityMoney = false
					this.tMoney = false
					this.money_isDesc = !this.money_isDesc
					this.num_isDesc = !this.num_isDesc
					this.quantitynum_isDesc = !this.quantitynum_isDesc
					this.quantitymoney_isDesc = !this.quantitymoney_isDesc
					this.tMoney_isDesc = !this.tMoney_isDesc
				}else if(type == 'quantitynum') {
					this.sort_field = 'sales_volume'
					this.orderByNum = false
					this.orderByMoney = false
					this.quantityNum = true
					this.quantityMoney = false
					this.tMoney = false
					this.money_isDesc = !this.money_isDesc
					this.num_isDesc = !this.num_isDesc
					this.quantitynum_isDesc = !this.quantitynum_isDesc
					this.quantitymoney_isDesc = !this.quantitymoney_isDesc
					this.tMoney_isDesc = !this.tMoney_isDesc
				}else if(type == 'quantitymoney'){
					this.sort_field = 'purchase_volume'
					this.orderByNum = false
					this.orderByMoney = false
					this.quantityNum = false
					this.quantityMoney = true
					this.tMoney = false
					this.money_isDesc = !this.money_isDesc
					this.num_isDesc = !this.num_isDesc
					this.quantitynum_isDesc = !this.quantitynum_isDesc
					this.quantitymoney_isDesc = !this.quantitymoney_isDesc
					this.tMoney_isDesc = !this.tMoney_isDesc
				}else {
					this.sort_field = 'purchase_amount'
					this.orderByNum = false
					this.orderByMoney = false
					this.quantityNum = false
					this.quantityMoney = false
					this.tMoney = true
					this.money_isDesc = !this.money_isDesc
					this.num_isDesc = !this.num_isDesc
					this.quantitynum_isDesc = !this.quantitynum_isDesc
					this.quantitymoney_isDesc = !this.quantitymoney_isDesc
					this.tMoney_isDesc = !this.tMoney_isDesc
				}
				this.getData()
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getData()
			},
			getData() {
				let param = {
					act: 'sub_agent_data',
					sort: this.num_isDesc?'desc':'asc',
					sort_field: this.sort_field,
					rank_id : 2,
					data_type : 'store',
					page: this.currentPage,
					size: 10,
					type: this.curIndex,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					keyword: this.search_input,
					start_month: this.start_month,
					end_month: this.end_month
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.rank = res.data
						this.total_records = parseInt(res.total_records)
					}else{
						this.rank = []
					}
				})
			},
		},
		mounted() {
			this.agent_id = this.$route.params.id
			this.getData()
		}
	}
</script>
<style>
	.el-input__icon {
		display: none;
	}

	.el-range__close-icon {
		display: none !important;
	}

	.el-range-separator {
		line-height: 1rem !important;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 0.75rem;
	}
</style>
<style lang="less" scoped>
	.rank {
		height: 100%;
		max-width: 73.24rem;
		margin: 0 auto;

		.search {
			width: 16.9rem;
			height: 1.69rem;
			position: relative;

			input {
				font-size: 0.75rem;
				outline: none;
				border: 2px solid #1E69FF;
				border-radius: 4px;
				padding: 0 1.44rem;
				height: 100%;
				width: 100%;
				box-sizing: border-box;
				&::placeholder{
					font-size: .75rem;
				}
			}

			.icon {
				background: #1E69FF;
				height: 100%;
				padding: 0 0.38rem;
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
				border-radius: 0 4px 4px 0;

				i {
					color: #FFFFFF;
				}
			}


			&::-webkit-input-placeholder {
				color: #BBBBBB;
				font-size: 0.77rem;
			}
		}

		.period {
			list-style: none;
			width: 30rem;
			height: 100%;
			cursor: pointer;
			font-size: 0.77rem;
			color: #666666;

			li {
				width: 5rem;
				height: 100%;
				border-radius: 4px;
				background: #FFFFFF;
				color: #1A6BFF;
				border: 2px solid #1A6BFF;
				box-sizing: border-box;

				&:hover {
					background: #1A6BFF;
					color: #FFFFFF;
				}

			}

			.active {
				background: #1A6BFF;
				color: #FFFFFF;
			}
		}

		.content {
			height: 40.88rem;
			width: 100%;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;

			.title {
				padding: 1.44rem;
			}

			.table {
				text-align: center;
				height: calc(100% - 1.44rem);

				.row {

					div,
					span {
						flex: 1;
					}
				}
			}
		}

		footer {
			width: 100%;
			height: 3.76rem;
			background: #FFFFFF;
			margin-top: 1.41rem;
			border-radius: 6px;
		}
	}
</style>
